import { makeStyles } from "@material-ui/core/styles";

const DARK = "#263238";
const BORDER_COLOR = "rgba(38, 50, 56, 0.5)";

export default makeStyles(() => ({
  cancel: {
    "& .MuiButton-root": {
      backgroundColor: "transparent",
      color: DARK,
      border: `1px solid ${BORDER_COLOR}`,
      boxShadow: "none",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "rgba(38, 50, 56, 0.04)",
      border: `1px solid ${BORDER_COLOR}`,
      boxShadow: "none",
    },
    "& .MuiButton-startIcon": {
      display: "none",
    },
  },
}));
